import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    component: () => import("@/layouts/PrincipalLayout.vue"),
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/views/HomeView.vue"),
        meta: {
          title: "R CAR | Renta de Autos en Morelia",
          description: "Renta de autos en Morelia desde $999/día con R CAR. Precios finales con seguro de cobertura amplia incluido y sin cargos ocultos. Entrega GRATIS en Aeropuerto (MLM) y domicilio. ¡Reserva y Renta un auto Hoy!",
        },
      },
      {
        path: "/buscador",
        name: "buscador",
        component: () => import("@/views/Buscador.vue"),
        props: true,
        meta: {
          title: "Busca tu Auto Ideal | R CAR Renta de Autos en Morelia",
          description: "Filtra por fechas, tipo de auto y ciudad. Encuentra el auto perfecto para tu viaje en Morelia con seguro incluido y entrega en aeropuerto.",
        },
      },
      {
        name: "login",
        path: "/login",
        component: () => import("@/views/Usuario/Login.vue"),
        meta: { title: "Iniciar Sesión | R CAR" },
      },
      {
        path: "/registro",
        name: "registro",
        component: () => import("@/views/Usuario/Registro.vue"),
        meta: { title: "Crear Cuenta | R CAR" },
      },
      {
        path: "/perfil",
        name: "perfil",
        component: () => import("@/views/Usuario/Perfil.vue"),
        meta: { title: "Mi Perfil | R CAR" },
      },
      {
        path: "/checkin/:uuid",
        name: 'checkin',
        component: () => import("@/views/Viaje/Checkin.vue"),
        meta: { title: "Check-In | R CAR" },
      },
      {
        path: "/reservar",
        name: "reservar",
        component: () => import("@/views/Viaje/Reserva.vue"),
        meta: { title: "Confirma tu Reservación | R CAR" },
      },
      {
        path: "/confirmaReserva",
        name: "confirmaReserva",
        component: () => import("@/views/Viaje/ConfirmaReserva.vue"),
        meta: { title: "Reservación Confirmada | R CAR" },
      },
      {
        path: "/encurso",
        name: "encurso",
        component: () => import("@/views/Viaje/EnCurso.vue"),
        meta: { title: "Viaje en Curso | R CAR" },
      },
      {
        path: "/detalle/:uuid",
        name: "detalle",
        component: () => import("@/views/Vehiculo/Detalle.vue"),
        meta: { title: "Detalle del Vehículo | R CAR" },
      },
      {
        path: "/test",
        name: "test",
        component: () => import("@/views/test.vue"),
        meta: { title: "R CAR" },
      },
      {
        path: "/success/:type",
        name: "success",
        component: () => import("@/views/Viaje/Success.vue"),
        meta: { title: "¡Listo! | R CAR" },
      },
      {
        path: "/reservactiva/:uuid",
        name: "reservactiva",
        component: () => import("@/views/Viaje/ReservaActiva.vue"),
        meta: { title: "Mi Reservación Activa | R CAR" },
      },
      {
        path: "/confirmacionpago/:uuid",
        name: "confirmacionpago",
        component: () => import("@/views/Viaje/ConfirmaPago.vue"),
        meta: { title: "Confirmación de Pago | R CAR" },
      },
      {
        path: "/auth/callback",
        name: "callback",
        component: () => import("@/views/AuthCallback.vue"),
        meta: { title: "R CAR" },
      },
      {
        path: "/host",
        name: "host",
        component: () => import("@/views/Host.vue"),
        meta: {
          title: "Vuélvete Anfitrión Host | R CAR Morelia",
          description: "Registra tu auto y genera ingresos rentándolo con R CAR en Morelia. Configura tus condiciones y cobra mensualmente.",
        },
      },
      {
        path: '/registroHost',
        name: 'registroHost',
        component: () => import('@/views/Usuario/HostWizard.vue'),
        meta: { requiresAuth: true, title: "Registro de Host | R CAR" }
      }
    ]
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const BASE_URL = 'https://rcar.mx'
const DEFAULT_DESCRIPTION = 'Renta de autos en Morelia desde $999/día con R CAR. Seguro incluido y entrega GRATIS en Aeropuerto (MLM). ¡Reserva hoy!'

router.afterEach((to) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })

  // Título dinámico
  const title = to.meta?.title || 'R CAR | Renta de Autos en Morelia'
  document.title = title

  // Meta description dinámica
  const desc = to.meta?.description || DEFAULT_DESCRIPTION
  let metaDesc = document.querySelector('meta[name="description"]')
  if (metaDesc) metaDesc.setAttribute('content', desc)

  // Canonical dinámico
  const canonical = document.getElementById('canonical-url')
  if (canonical) canonical.setAttribute('href', `${BASE_URL}${to.path}`)

  // Open Graph dinámico
  const ogTitle = document.querySelector('meta[property="og:title"]')
  if (ogTitle) ogTitle.setAttribute('content', title)
  const ogDesc = document.querySelector('meta[property="og:description"]')
  if (ogDesc) ogDesc.setAttribute('content', desc)
  const ogUrl = document.querySelector('meta[property="og:url"]')
  if (ogUrl) ogUrl.setAttribute('content', `${BASE_URL}${to.path}`)
})


export default router
